import { CoachPageWithData, COACH_QUERY } from '@layouts/coach'
import { fetchSSRData } from '@lib/ssr-fetch'
import { searchCoachProfileOfferings } from '@lib/pga-coach/offering-search'
import initializeFeatures from '@lib/feature-flags/initializeFeatures'
import { flags } from '@lib/feature-flags/constants'

function CoachPage(props) {
  return (
    <CoachPageWithData {...props} />
  )
}

CoachPage.getInitialProps = async (ctx) => {
  const { query } = ctx
  const result = await fetchSSRData({
    query,
    graphqlQuery: COACH_QUERY,
    variables: { customSlug: query.slug },
    clientName: 'coach-tools',
    transform: (data) => data?.CoachProfiles?.profiles?.[0],
  })
  // The bare /coach/<slug> URL is the canonical About surface; the per-section
  // sibling route (`[section].js`) supplies its own `section` value.
  const featureFlags = await initializeFeatures(ctx).catch(() => ({}))
  const coachProfileUxEnabled = Boolean(featureFlags?.[flags.FLAG_COACH_PROFILE_UX])
  const coachId = result.data?.coach?.id
  if (coachProfileUxEnabled && coachId) {
    try {
      const { offeringsByPersona } = await searchCoachProfileOfferings(coachId)
      return {
        ...result,
        ssrData: result.data,
        section: 'about',
        coachProfileUxEnabled: true,
        initialOfferingsByPersona: offeringsByPersona,
      }
    } catch (e) {
      // Fail open: render About and let the client retry on transient Algolia errors.
    }
  }
  return {
    ...result,
    ssrData: result.data,
    section: 'about',
    coachProfileUxEnabled,
  }
}

export default CoachPage
